import { Routes } from '@angular/router';

export const ecGoodsRoutes: Routes = [
  {
    path: 'ec/goods/:goodsGrpId',
    data: {
      title: 'EC 상품 관리',
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/ec-goods-list-page/ec-goods-list-page.component'
          ).then((m) => m.EcGoodsListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/ec-goods-detail-page/ec-goods-detail-page.component'
              ).then((m) => m.EcGoodsDetailPageComponent),
            data: {
              title: 'EC 상품 상세',
            },
          },
        ],
      },
    ],
  },
];
